export default __webpack_public_path__ + "static/media/nomad.62f1bd69.png";